/* @format */

import EventBus from '@/scripts/event-bus';

/**
 * @typedef {Object} OpenRegisteredDealWidgetConfig
 * @property {string} context - The context of the widget.
 * @property {number} [registeredDealId] - The ID of the registered deal.
 * @property {number} [opportunityId] - The ID of the opportunity.
 * @property {number} [agencyId] - The ID of the agency.
 * @property {number} [clientId] - The ID of the client.
 * @property {number} [clientAccountId] - The account ID of the client.
 * @property {boolean} [edit] - Whether the widget is in edit mode.
 * @property {boolean} [add] - Whether the widget is in add mode.
 */

export const REGISTERED_DEAL_WIDGET_NAME = 'registered-deal-widget';

export const REGISTERED_DEAL_WIDGET_CONTEXT = {
    CLIENT: 'CLIENT',
    AGENCY: 'AGENCY',
};

export const REGISTERED_DEAL_WIDGET_ATTEMPT_SAVE_EVENT = 'registered-deal-widget:attempt-save';

/**
 * Open the registered deals widget.
 *
 * @param {OpenRegisteredDealWidgetConfig} config - The configuration for the widget.
 */
export function openRegisteredDealWidget(config) {
    if (!config.add && config.registeredDealId == null) {
        throw new Error('No registered deal ID provided for the registered deal widget.');
    }

    if (!config.context) {
        throw new Error('No context provided for the registered deal widget.');
    }

    if (config.context === REGISTERED_DEAL_WIDGET_CONTEXT.AGENCY && !config.agencyId) {
        throw new Error('No agency ID provided for the registered deal widget.');
    }

    EventBus.$emit('open-widget', {
        name: REGISTERED_DEAL_WIDGET_NAME,
        registeredDealId: config.registeredDealId,
        context: config.context,
        opportunityId: config.opportunityId ?? null,
        agencyId: config.agencyId ?? null,
        clientId: config.clientId ?? null,
        clientAccountId: config.clientAccountId ?? null,
        edit: config.edit ?? false,
        add: config.add ?? false,
    });
}
